<template>
    <aside class="settings-menu">
        <div class="title">Settings</div>
        <div class="header" v-if="$store.state.user_data">
            <div class="info">
                <figure class="avatar">
                    <img v-if="$store.state.user_data.avatar" :src="$store.state.user_data.avatar" />
                    <img v-else :src="require('@/assets/images/user.png')" />
                </figure>
                <div class="desc">
                    <div class="name">{{ $store.state.user_data.first_name + ' ' + $store.state.user_data.last_name }}</div>
                    <div class="email">{{ $store.state.user_data.email }}</div>
                </div>
            </div>
            <router-link :to="'/settings/account'"
                :class="{ 'router-link-active': $route.params.type === 'security' }"><span>Your Account</span><svg-icon
                    name="arrow-next" /></router-link>
        </div>
        <div class="settings-box" v-if="$store.state.user_data.merchant_account">
            <div>
                <div class="text">Workspace</div>
                <router-link :to="'/settings/company'" v-if="permission.settingWorkspace.manageSettings.permission"><span>Company</span><svg-icon name="arrow-next" /></router-link>
                <router-link :to="'/settings/team'"><span>Team</span><svg-icon name="arrow-next" /></router-link>
            </div>
            <div v-if="$store.state.user_data.merchant_account !== null">
                <div class="text">Integrations</div>
                <router-link :to="'/settings/domain-edit'" v-if="permission.settingIntegrations.integrations.permission" :class="{ 'router-link-active': $route.params.type === 'domain-edit' }">
                    <span>Domain</span>
                    <svg-icon v-if="$store.state.user_data.merchant_account.is_enable_merchant_host === 0" name="lock" />
                    <svg-icon name="arrow-next" />
                </router-link>
                <router-link :to="'/settings/script'" v-if="permission.settingIntegrations.integrations.permission"> 
                    <span>Script Manager</span>
                    <svg-icon v-if="$store.state.user_data.merchant_account.is_enable_script_manager === 0" name="lock" />
                    <svg-icon name="arrow-next" />
                </router-link>
                <router-link :to="'/settings/storefront-img'" :class="{'router-link-active': $route.params.type === 'permissions' || $route.params.type === 'content-listening'}">
                    <span>Customizations</span>
                    <svg-icon name="arrow-next" />
                </router-link>
            </div>
            <!-- <div class="text">Design</div>
            <router-link :to="'/settings/storefront'"><span>Storefront themes</span><svg-icon
                    name="arrow-next" /></router-link>
            <router-link :to="'/settings/custom'"><span>Custom invites</span><svg-icon name="arrow-next" /></router-link> -->
        </div>

        <queue-progress :isStatic="true" />
    </aside>
</template>

<script>
import SvgIcon from '../ui/SvgIcon.vue';


export default {
    name: 'Menu',
    components: { SvgIcon },
    computed:{
        permission(){
            return this.$store.state.user_data?.permission_list;
        }
    }
}
</script>
<style lang="scss">
.settings-menu {
    width: 263px;
    min-width: 263px;
    padding: 16px 8px;
    background: var(--bg-10);
    border-radius: 8px;
    align-self: flex-start;

    .title {
        font: var(--font-demi-30);
        color: var(--black-90);
        padding: 0 8px 8px;
    }

    .header {
        // margin: 16px 0;
        padding: 16px 0 16px;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);

        .info {
            display: flex;
            margin-bottom: 7px;

            .avatar {
                height: 62px;
                width: 62px;
                background-color: var(--black-20);
                overflow: hidden;
                border-radius: 50%;

                img {
                    height: 100%;
                    width: 100%;
                    display: block;
                    object-fit: contain;
                }
            }

            .desc {
                margin-left: 12px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                .name {
                    font: var(--font-fg-12);
                    color: var(--black-75);
                }

                .email {
                    font-family: var(--font);
                    font-weight: 400;
                    font-size: 12px;
                    color: var(--black-50);
                }
            }
        }


        a {
            display: flex;
            align-items: center;
        }
    }

    .text {
        padding: 8px;
        font-family: var(--font);
        font-weight: 400;
        font-size: 12px;
        color: var(--black-60);
    }

    .settings-box {
        & > div {
            margin: 16px 0;
        }
    }

    a {
        padding: 0 8px;
        height: 32px;
        font: var(--font-fg-14);
        color: var(--black-90);
        display: flex;
        align-items: center;
        background: rgba(0, 0, 0, 0);
        transition: .2s all ease;

        &.router-link-active,
        &:hover {
            background: rgba(0, 0, 0, 0.03);

            .svg-icon--arrow-next {
                width: 10px;
                margin-left: 6px;
            }
        }

        span {
            flex: 1;
            color: var(--black-90) !important;
        }

        .svg-icon--lock {
            width: 16px;
            height: 16px;
            fill: var(--black-50);

            & + svg {
                display: none !important;
            }
        }

        // .svg-icon--alert {
        //     width: 14px;
        //     height: 14px;
        //     color: var(--alert);
        // }

        .svg-icon--arrow-next {
            width: 0px;
            height: 10px;
            margin-left: 0px;
            color: var(--black-50);
            transition: .2s all ease;
        }
    }

    .queue-progress-container.static .queue-progress-card {
        margin: 0 8px;
    }
}

.settings-content {
    .title {
        font-family: var(--font-demi);
        font-size: 30px;
        font-weight: 400;
        line-height: 48px;
    }


}
</style>

